import src from "IMAGE";
export default { src, width: 448, height: 512, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
